import React from 'react';
import PropTypes from 'prop-types';

import { List as MuiList } from '@material-ui/core';

const List = ({ children, ...rest }) => {
  return (
    <MuiList
      {...rest}
    >
      { children }
    </MuiList>
  )
}

List.defaultProps = {
  children: null,
}

List.propTypes = {
  children: PropTypes.node,
}

export default List;



// WEBPACK FOOTER //
// ./src/components/base/List/List.js